import { textLinkClass } from '../ui/text-link';

// TODO(product): the public legal pages (/legal/terms, /legal/privacy) are not built yet; these point at their planned URLs.
/** "Terms of Service and Privacy Policy" with both linked, for use inside a sentence. */
export function TermsLinks() {
  return (
    <>
      <a href="/legal/terms" target="_blank" rel="noreferrer" className={textLinkClass}>
        Terms of Service
      </a>{' '}
      and{' '}
      <a href="/legal/privacy" target="_blank" rel="noreferrer" className={textLinkClass}>
        Privacy Policy
      </a>
    </>
  );
}
